import { combineReducers } from 'redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import changelogWidget from 'common/reducers/changelogWidget';
import cookies from 'common/reducers/cookies';
import serverResponse from 'common/reducers/serverResponse';

export default combineReducers({
  changelogWidget,
  cookies,
  reduxAsyncConnect,
  serverResponse,
});
